// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__7qPQa","mainWrapper":"styles_mainWrapper__AR4Dh","viewBody":"styles_viewBody__iSGWC","pageContent":"styles_pageContent__Pdy1d"};